// ADR 30.9.26l §3 — the account row, merged again at sign-in.
//
// `main.tsx` merges the row once, at boot. A visitor who accepted anonymously
// and then signs in to an account that opted out on a phone would otherwise
// stay measured until the next load. So on each `signedOut` → `signedIn`
// transition — a sign-in in this page — the row is merged again. The boot
// transition `loading` → `signedIn` is skipped: the start-up reconcile already
// covers a restored session.
//
// The merge is most-restrictive-wins, so this can withdraw and never grant,
// and it preserves the answered marker without ever adding it. Renders
// nothing; mounted beside `ReminderReconcile`, outside the frame.

import { useEffect, useRef } from 'react'

import { useAuthSession } from '../auth/session'
import { reconcileAccountRow } from '../telemetry'

export function ConsentReconcile() {
  const { status } = useAuthSession()
  const previous = useRef(status)
  useEffect(() => {
    const was = previous.current
    previous.current = status
    // `reconcileAccountRow` never rejects: a failed `GET` leaves the record.
    if (was === 'signedOut' && status === 'signedIn') void reconcileAccountRow()
  }, [status])
  return null
}
